import Enum from "../../../enums/Enum";

const EligibilityStatusEnum = new Enum({
    PENDING: {name: "Pending"},
    ELIGIBLE: {name: "Eligible"},
    INELIGIBLE: {name: "Ineligible"}
});

export default EligibilityStatusEnum;
